export default __webpack_public_path__ + "static/4-cb83686790677bbcd77756cd0f7fa09c.svg";